/** @file toExportParams: an ExportQuery as string query parameters (arrays as comma lists). */
import type { BakedExportOptions, ExportQuery } from '../types/restAdded';

/** The baked option keys in a fixed order, so the same query always gives the same URL (the server caches by it). */
const KEYS = ['directions', 'clips', 'scale', 'trim', 'cameraYaw', 'cameraPitch', 'variants', 'grid'] as const satisfies readonly (keyof BakedExportOptions)[];

/** `{ format: 'baked', directions: 8, clips: ['idle'] }` → `{ format: 'baked', directions: '8', clips: 'idle' }`; a bundle → `{}`. */
export function toExportParams(q: ExportQuery = {}): Record<string, string> {
  if (q.format !== 'baked') return {};
  const out: Record<string, string> = { format: 'baked' };
  for (const key of KEYS) {
    const value = q[key];
    if (value !== undefined) out[key] = Array.isArray(value) ? value.join(',') : String(value);
  }
  return out;
}
